import { useContext, useEffect, useState } from 'react';
import { TranslationContext } from 'contexts/translation-context';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { errorList, errorListTypes } from 'constants/error-list';
import { PlanState } from '../reducers/plan';
import { Row } from 'components/common/grid';
import { Link, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { JoinFormType } from 'types/join';

type TextProps = {
  isPriceList?: boolean;
};

const Text = styled(Typography)<TextProps>(({ isPriceList }) => ({
  fontSize: '12px',
  marginLeft: '-10px',
  width: isPriceList ? '270px' : '200px'
}));
const StyledLink = styled(Link)(() => ({
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline'
  }
}));

const ErrorContainer = styled.div<{ top?: string }>`
  position: relative;
  ${props => props.top && `top:${props.top}`};
  color: ${props => props.theme.colors.black};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 12px;
`;

type EmailErrorsTextsExistsProps = {
  isPriceList?: boolean;
  showErrorPopup: { numOfTries: 0; show: boolean; errorMessage?: string | null };
  form: FormikProps<JoinFormType>;
};

export const EmailErrorsTextsExists = ({
  isPriceList,
  showErrorPopup,
  form
}: EmailErrorsTextsExistsProps) => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  const [showError, setShowError] = useState(false);

  const errorMessageType = errorList[showErrorPopup.errorMessage || ''] || '';

  useEffect(() => {
    if (showErrorPopup.numOfTries > 0) {
      setShowError(true);
    }
  }, [showErrorPopup]);
  if (showError) {
    if (errorMessageType) {
      if (!isPriceList && errorMessageType === errorListTypes.emailAlreadyExists) {
        return (
          <ErrorContainer top="8px">
            <Row>
              <Text variant="body2" isPriceList={isPriceList}>
                {TRANSLATION_TEXT.email_already_exists_please}{' '}
                <StyledLink
                  href={
                    isPriceList ? 'https://rapaport.com/authorization/' : CONFIG.RAPNET_LOGIN_URL
                  }
                  underline="always"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {TRANSLATION_TEXT.log_in_lower_case}
                </StyledLink>{' '}
                {`${TRANSLATION_TEXT.to_your} ${
                  isPriceList ? TRANSLATION_TEXT.rapaport : TRANSLATION_TEXT.rapnet
                }${TRANSLATION_TEXT.account_or}`}{' '}
                <StyledLink
                  href="https://www.rapnet.com/contact/support/"
                  underline="always"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {TRANSLATION_TEXT.contact_us}
                </StyledLink>{' '}
                {TRANSLATION_TEXT.for_support}
              </Text>
            </Row>
          </ErrorContainer>
        );
      }
      if (errorMessageType === errorListTypes.emailIsNotValid) {
        return (
          <ErrorContainer>
            <div>{TRANSLATION_TEXT.email_is_not_valid}</div>
          </ErrorContainer>
        );
      }
    }
  }
  if (form.touched.email && form.errors.email && form.errors.email !== 'Required') {
    return <>{form.errors.email}</>;
  }

  return null;
};
